import { render } from "./IosLanding.vue?vue&type=template&id=228811e7&scoped=true"
import script from "./IosLanding.vue?vue&type=script&lang=js"
export * from "./IosLanding.vue?vue&type=script&lang=js"

import "../../public/wts.css?vue&type=style&index=0&id=228811e7&lang=css&scoped=true"
import "./IosLanding.vue?vue&type=style&index=1&id=228811e7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228811e7"]])

export default __exports__